import { ShieldCheck, MagnifyingGlass, CurrencyDollar } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

const iconMap = {
  'Licensed & Insured': ShieldCheck, 'Licenciado y Asegurado': ShieldCheck,
  'Free Inspection': MagnifyingGlass, 'Inspección Gratuita': MagnifyingGlass,
  'Free Estimate': MagnifyingGlass, 'Presupuesto Gratuito': MagnifyingGlass,
  'Financing Available': CurrencyDollar, 'Financiamiento Disponible': CurrencyDollar,
  'Insurance Savings': CurrencyDollar, 'Ahorro en Seguro': CurrencyDollar,
  'Same-Day Service': ShieldCheck, 'Servicio el Mismo Día': ShieldCheck,
};

export default function TrustBadges({ badges }) {
  if (!badges || badges.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-4 justify-center" data-testid="trust-badges">
      {badges.map((badge, i) => {
        const Icon = iconMap[badge] || ShieldCheck;
        return (
          <motion.div key={i} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
            className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2.5">
            <Icon size={20} weight="regular" className="text-[#E31937]" />
            <span className="text-xs font-bold text-white uppercase tracking-wider">{badge}</span>
          </motion.div>
        );
      })}
    </div>
  );
}
